import { useEffect } from "react";

export function usePageMeta(title, description, image = "", type = "website") {
  useEffect(() => {
    document.title = title.includes("Dutsen") ? title : `${title} | Dutsen Kauna Foundation`;
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) { meta = document.createElement("meta"); meta.name = "description"; document.head.appendChild(meta); }
      meta.content = description;
    }
    let canon = document.querySelector('link[rel="canonical"]');
    if (!canon) { canon = document.createElement("link"); canon.rel = "canonical"; document.head.appendChild(canon); }
    canon.href = window.location.origin + window.location.pathname;
    const full = document.title;
    const img = image ? (image.startsWith("http") ? image : window.location.origin + image) : window.location.origin + "/dk-logo-dark.png";
    const tags = { "og:title": full, "og:description": description || "", "og:url": canon.href, "og:image": img, "og:type": type,
      "twitter:card": "summary_large_image", "twitter:title": full, "twitter:description": description || "", "twitter:image": img };
    Object.entries(tags).forEach(([k, v]) => {
      const isTw = k.startsWith("twitter:");
      let el = document.querySelector(isTw ? `meta[name="${k}"]` : `meta[property="${k}"]`);
      if (!el) { el = document.createElement("meta"); if (isTw) el.name = k; else el.setAttribute("property", k); document.head.appendChild(el); }
      el.content = v;
    });
  }, [title, description, image, type]);
}

// Injects (and replaces) a JSON-LD block keyed by id. Pass null to remove.
export function useJsonLd(id, data) {
  useEffect(() => {
    const key = `jsonld-${id}`;
    let el = document.getElementById(key);
    if (!data) { el?.remove(); return; }
    if (!el) { el = document.createElement("script"); el.type = "application/ld+json"; el.id = key; document.head.appendChild(el); }
    el.textContent = JSON.stringify({ "@context": "https://schema.org", ...data });
    return () => el?.remove();
  }, [id, JSON.stringify(data)]); // eslint-disable-line react-hooks/exhaustive-deps
}

export const ORG_LD = { "@type": "NGO", name: "Dutsen Kauna Foundation", url: typeof window !== "undefined" ? window.location.origin : "", logo: "/dk-logo.png", email: "foundation@dutsenkauna.org", telephone: "+2348063550963", areaServed: { "@type": "State", name: "Adamawa State, Nigeria" }, nonprofitStatus: "Nonprofit501c3" };

export const breadcrumbs = (items) => ({ "@type": "BreadcrumbList", itemListElement: items.map(([name, path], i) => ({ "@type": "ListItem", position: i + 1, name, item: window.location.origin + path })) });
